import {
  ALLOCATE_PLA_FAILURE,
  ALLOCATE_PLA_REQUEST,
  ALLOCATE_PLA_SUCCESS,
  DEFER_SLP_FAILURE,
  DEFER_SLP_REQUEST,
  DEFER_SLP_SUCCESS,
  GET_AUDIT_TRAIL_LIST_FAILURE,
  GET_AUDIT_TRAIL_LIST_REQUEST,
  GET_AUDIT_TRAIL_LIST_SUCCESS,
  GET_CONTACT_NOTE_FAILURE,
  GET_CONTACT_NOTE_REQUEST,
  GET_CONTACT_NOTE_SUCCESS,
  DELETE_COMPLETED_SLP_FAILURE,
  DELETE_COMPLETED_SLP_REQUEST,
  DELETE_COMPLETED_SLP_SUCCESS,
  GET_COMPLETED_SLP_DETAILS_FAILURE,
  GET_COMPLETED_SLP_DETAILS_REQUEST,
  GET_COMPLETED_SLP_DETAILS_SUCCESS,
  NEXT_OR_CURRENT_SLP_FAILURE,
  NEXT_OR_CURRENT_SLP_REQUEST,
  NEXT_OR_CURRENT_SLP_SUCCESS,
  GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST,
  GET_ALL_SLP_GOALS_AND_ASSESSMENT_SUCCESS,
  GET_ALL_SLP_GOALS_AND_ASSESSMENT_FAILURE,
  UPDATE_CONTACT_DATE_REQUEST,
  UPDATE_CONTACT_DATE_SUCCESS,
  UPDATE_CONTACT_DATE_FAILURE,
} from "./actionTypes";
import {
  StudentProfileDetailsActions,
  StudentProfileDetailsState,
} from "./types";

const initialState: StudentProfileDetailsState = {
  pending: false,
  error: null,
};

const reducers = (
  state = initialState,
  action: StudentProfileDetailsActions
): unknown => {
  switch (action.type) {
    case NEXT_OR_CURRENT_SLP_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case NEXT_OR_CURRENT_SLP_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case NEXT_OR_CURRENT_SLP_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case DEFER_SLP_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case DEFER_SLP_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case DEFER_SLP_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case ALLOCATE_PLA_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ALLOCATE_PLA_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case ALLOCATE_PLA_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_CONTACT_NOTE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_CONTACT_NOTE_SUCCESS:
      return {
        ...state,
        pending: false,
        sLPContactNote: action.payload.item,
        error: null,
      };
    case GET_CONTACT_NOTE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_AUDIT_TRAIL_LIST_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_AUDIT_TRAIL_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        auditTrailList: action.payload.auditTrailList,
        error: null,
      };
    case GET_AUDIT_TRAIL_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case DELETE_COMPLETED_SLP_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case DELETE_COMPLETED_SLP_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case DELETE_COMPLETED_SLP_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_COMPLETED_SLP_DETAILS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_COMPLETED_SLP_DETAILS_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case GET_COMPLETED_SLP_DETAILS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_ALL_SLP_GOALS_AND_ASSESSMENT_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case GET_ALL_SLP_GOALS_AND_ASSESSMENT_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case UPDATE_CONTACT_DATE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case UPDATE_CONTACT_DATE_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
      };
    case UPDATE_CONTACT_DATE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducers;
